import React from "react";
import PropTypes from "prop-types";

const AccountModalHeaderText = ({
    accountModalTitle,
    renderAccountModalDescription,
}) => (
    <div className="account-modal-header-text">
        <div className="grid">
            <div className="col col--12">
                <h1>{accountModalTitle}</h1>
            </div>
        </div>
        <div className="grid">
            <div className="col col--12">
                {/* Returns the markup for all of the different versions of the description */}
                {renderAccountModalDescription()}
            </div>
        </div>
    </div>
);

AccountModalHeaderText.propTypes = {
    accountModalTitle: PropTypes.string.isRequired,
    renderAccountModalDescription: PropTypes.func.isRequired,
};

export default AccountModalHeaderText;
